// extracted by mini-css-extract-plugin
export default {"root":"ng1U6","row":"nHMkL","icon":"FkjFe","temp":"MzDzZ","pollutionTitle":"RryAT","pollutionQuality":"V3jYd"};